import constants from '@/app-configs/constants'

export default [
  {
    path: '/admin-settings',
    name: 'admin-settings',
    component: () => import('@/views/adminsetting/CombinedAdminSettings.vue'),
    meta: {
      pageTitle: 'DEBTIA_ADMIN_SETTINGS',
      breadcrumb: [
        {
          text: 'DEBTIA_ADMIN_SETTINGS',
          active: true,
        },
      ],
      action: constants.action.permissionLogin,
      resource: constants.resource.user,
    },
  },
]
